var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./FullCalendar.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-467b2bdf!../../vue-loader/lib/selector?type=template&index=0!./FullCalendar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-full-calendar/components/FullCalendar.vue
// module id = 552
// module chunks = 97